<template>
  <div id="dragAndDrop">
    <div class="grid-drag-and-drop">
      <Board id="board-1" :selection=false @card-dropped="decrement">
        <!-- v-for only UNSELECTED items v-if="item.value === store.$state.selectedValues[cardId]"  -->

        <card
          v-for="(item, index) in unselectedValues" :key="index"
          draggable="true"
          :category="item.category"
          :id="item.id"
          :value="item.value"
          :output="item.alt"
          :title="item.title || ''">
            <sb-image :src="item.img" :alt="item.alt" />
        </card>
      </Board>

      <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-helper svg-inline--fa fa-arrow-right fa-w-14 fa-7x"><path fill="currentColor" d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z" class=""></path></svg>

      <Board id="board-2" :selection=true :limit="limit" :childs="childs" @card-dropped="increment" :class="'with-help-text'">
        <card
          v-for="(item, index) in selectedValues" :key="index"
          draggable="true"
          :category="item.category"
          :id="item.id"
          :value="item.value"
          :output="item.alt">
            <sb-image :src="item.img" :alt="item.alt" />
        </card>
      </Board>
    </div>
  </div>
</template>

<script>
import Board from './Board';
import Card from '../Card'
import SbImage from '../SbImage/SbImage'

export default {
  name: 'DragAndDrop',
  components: {
    Board,
    Card,
    SbImage
  },
  props: ['content', 'category', 'value', 'limit'],
  data() {
    return {
      childs: 0,
      selectedValues: [],
      unselectedValues: [],
    }
  },
  methods: {
    increment() {
      this.childs++
    },
    decrement() {
      this.childs--
    },
    sortSelected() {
      let localArr = JSON.parse(localStorage['challenges']) || [];

      if (localArr.length > 0) {
        this.selectedValues = {};
        this.unselectedValues = [];

        for (let contentItem of this.content) {
          let selected = false;

          for (let localItem of localArr) {

            if (localItem === contentItem.alt) {
              selected = true;
              contentItem.isSelected = true;
              this.selectedValues[contentItem.id] = contentItem;
              this.$store.state.selectedValues[contentItem.id] = contentItem;
            }
          }

          if (!selected) {
            this.unselectedValues.push(contentItem)
          }
        }

        this.childs = Object.keys(this.selectedValues).length;
      } else {
        this.unselectedValues = this.content;
        this.selectedValues = {};
      }
    },
  },
   mounted() {
    this.$nextTick(() => {
      this.sortSelected();
    })
  },
}
// sort() renders the cards, so if the cards aren't rendered they can't be sorted
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .grid-drag-and-drop {
    display: grid;
    grid-gap: 11px;
  }

  @media (min-width: 576px) {
    .grid-drag-and-drop {
      grid-template-columns: 4fr 60px 1fr;
    }
  }

  .svg-helper {
    transform: rotate(90deg);
    padding-right: 10px;
    opacity: 0.3;
    max-width: 50px;
    margin: 0 auto;
  }

  @media (min-width: 576px) {
    .svg-helper {
      transform: rotate(0);
      max-width: 100%;
      align-self: center;
    }
  }

  h1 {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  img,
  object {
    margin: 0 auto;
    display: block;
    /* max-height: 170px; */
  }

  .board {
    position: relative;
    z-index: 1;
  }

  .board.with-help-text {
    background: url('../../assets/page-2/solution-configurator-page-2-problems-bg-mobile.png') #efefef;
    background-position: top left;
    background-size: contain;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;
  }
  

  @media (min-width: 576px) {
    .board.with-help-text {
      background: url('../../assets/page-2/solution-configurator-page-2-problems-bg.png') #efefef;
    background-position: top left;
    background-size: contain;
      grid-template-rows: 1fr 1fr 1fr;
      grid-template-columns: 1fr;
    }
  }

  .card {
    background-color: #fff;
  }

</style>
